import { useQuery } from '@tanstack/react-query';
import API from 'services/api/index';
import QUERY_KEYS from 'services/api/queryKeys';
import { ONE_DAY_IN_MS, ONE_HOUR_IN_MS } from 'constants/time';

export const useGetCountries = () => {
  const { data, status, isLoading, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.GET_COUNTRIES],
    queryFn: API.common.getCountries,
    staleTime: ONE_HOUR_IN_MS, // 1 hour fresh
    gcTime: ONE_DAY_IN_MS
  });

  return {
    data,
    status,
    isLoading,
    isFetching
  };
};
